import { render, staticRenderFns } from "./ManagementDestinationAccess.vue?vue&type=template&id=bb2add10&scoped=true&"
import script from "./ManagementDestinationAccess.vue?vue&type=script&lang=ts&"
export * from "./ManagementDestinationAccess.vue?vue&type=script&lang=ts&"
import style0 from "./ManagementDestinationAccess.vue?vue&type=style&index=0&id=bb2add10&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb2add10",
  null
  
)

export default component.exports